module.exports = __webpack_public_path__ + "static/assets/e3af35844a01f8f64d2bea326db21a35.mp3";